import * as tslib_1 from "tslib";
import { ConflictStrategyBase } from "../library/ConflictStrategyBase";
var IgnoreConflictStrategy = (function (_super) {
    tslib_1.__extends(IgnoreConflictStrategy, _super);
    function IgnoreConflictStrategy() {
        return _super.call(this) || this;
    }
    IgnoreConflictStrategy.prototype.resolveConflict = function (changedAsset, oldAsset, assetsDictionary, precedence) {
        // Do nothing, ignore the fact that there is a conflict.
        return;
    };
    IgnoreConflictStrategy.prototype.create = function () {
        return new IgnoreConflictStrategy();
    };
    return IgnoreConflictStrategy;
}(ConflictStrategyBase));
export { IgnoreConflictStrategy };



// WEBPACK FOOTER //
// ../dist/lib/library/IgnoreConflictStrategy.js